import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => (
  <div className="m-4 pb-4 text-[18px] text-white">
    <Link className="text-white" to="/terms">
      Terms
    </Link>
    {' · '}
    <Link className="text-white" to="/privacy">
      Privacy
    </Link>
    {' · '}
    <Link className="text-white" to="/faq">
      FAQ
    </Link>
    {' · '}
    <Link className="text-white" to="/discordBot">
      Discord Bot
    </Link>
  </div>
);
